'use client';

import Image from 'next/image';
import Link from 'next/link';
import { IconArrowRight, IconCheck } from '@tabler/icons-react';
import AuthUI from '@/components/AuthUI';
import styles from '@/app/(website)/oauth/consent/consent.module.css';

export function ConnectionSignIn({
  subscribeEmail,
  passwordSignInHref,
}: {
  subscribeEmail: (email: string) => Promise<boolean>;
  passwordSignInHref?: string;
}) {
  return (
    <section className={styles.pageRoot}>
      <div className={styles.card}>
        <div className={styles.identity}>
          <span className={styles.owl}>
            <Image src="/owl.svg" alt="" width={28} height={29} />
          </span>
          <span>OwlScran</span>
        </div>
        <h1>One account. Your page.</h1>
        <p className={styles.intro}>
          Create a free account or sign in to save and publish your link in bio.
        </p>
        <p className={styles.reassurance}>
          <IconCheck size={17} aria-hidden /> No social accounts or payment details needed.
        </p>
        <div className={styles.authForm}>
          <AuthUI bespoke connection subscribeEmail={subscribeEmail} emailAlreadySubscribed />
        </div>
        <p className={styles.nextStep}>
          <IconArrowRight size={16} aria-hidden /> Next, review access and return to your app.
        </p>
        {passwordSignInHref && (
          <p className={styles.nextStep}>
            <Link href={passwordSignInHref}>Sign in with a password</Link>
          </p>
        )}
      </div>
    </section>
  );
}
